import { render, staticRenderFns } from "./_account-history.vue?vue&type=template&id=864583de&scoped=true&"
import script from "./_account-history.vue?vue&type=script&lang=js&"
export * from "./_account-history.vue?vue&type=script&lang=js&"
import style0 from "./_account-history.vue?vue&type=style&index=0&id=864583de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864583de",
  null
  
)

export default component.exports